export enum AutomaticSizeFilter {
  UNSPECIFIED = 0,
  // Automatic size filtering based on the size suggestions coming from Fit Analytics.
  //
  // The size filter is computed based on the recommendations that are given for the first page of products.
  // The first page is then not filtered because this would negatively impact performance.
  SIZE_FINDER = 1,
  // Automatic filtering based on the User Sizes from BI.
  //
  // In case the client sends a size filter and the sizes saved differ from the ones saved on BI side,
  // the server will return a Stream Item indicating this so the user can save their new sizes.
  //
  // If no size filter is sent, the server may attempt to suggest a size filter.
  // The suggested size filter will be returned in the applied filters of the response
  // and the items of the stream will contain an item indicating that the server has applied the automatic size filter.
  USER_SIZES = 3,
}
